import React from "react";
import { connect } from "react-redux";
import { setSiteNotes } from "../../../store/actions";

const getDefaultCategoryId = (categories) =>
  categories.length ? String(categories[0].id) : "";

class NoteTagCreate extends React.Component {
  static defaultProps = {
    site: {},
    categories: [],
    onError: () => console.error("Error in NoteTagCreate component."),
  };

  constructor(props) {
    super(props);
    this.state = {
      categoryId: getDefaultCategoryId(props.categories),
      noteValue: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.categories !== this.props.categories) {
      const categoryId = getDefaultCategoryId(this.props.categories);
      if (categoryId && !this.state.categoryId) {
        this.setState({ categoryId });
      }
    }
  }

  handleCategoryChange = (event) => {
    this.setState({ categoryId: event.target.value });
  };

  handleNoteValueChange = (event) => {
    this.setState({ noteValue: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { categoryId, noteValue } = this.state;
    if (!categoryId) {
      return;
    }

    this.props.onCreateNote(Number(categoryId), noteValue);
    this.setState({ noteValue: "" });
  };

  render() {
    const { categories } = this.props;
    const { categoryId, noteValue } = this.state;

    if (!categories.length) {
      return null;
    }

    return (
      <form className="create-note-form" onSubmit={this.handleSubmit}>
        <label className="create-note-form__label">
          Category
          <select
            className="form-control"
            value={categoryId}
            onChange={this.handleCategoryChange}
          >
            {categories.map((category) => (
              <option key={category.id} value={String(category.id)}>
                {category.name}
              </option>
            ))}
          </select>
        </label>
        <label className="create-note-form__label">
          Note
          <textarea
            className="form-control"
            rows={3}
            value={noteValue}
            placeholder="Enter note text"
            onChange={this.handleNoteValueChange}
          />
        </label>
        <button type="submit" className="button" disabled={!categoryId}>
          Add note
        </button>
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  siteNotes: state.siteNotes.data,
});

const mapDispatchToProps = (dispatch) => ({
  setSiteNotes: (notes) => dispatch(setSiteNotes(notes)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NoteTagCreate);
